import { Box, Button, Paper, Stack, TextField, Tooltip, Typography, IconButton, Card } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import "../PharmacyPurchase/PharmaPurchase.css"
import { ImagePaths } from '../../../Utility/ImagePaths';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions';

let RoleData = null;
let userAccess = null;
let subUserAccess = null;

class PharmaISPoEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      pageSize: 10,
      rowCount: 0,
      WantedListData: [],
      VendorList: [],
      SelectedWantedList: [],
      searchkey: "",
      FilterOpen: false,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: '',
      prevHistory: false,
      prevVendorData: {},
      sendWantedListData: [],
      pharmacy_id: this.props.history?.location?.state?.pharmacy_id ? this.props.history?.location?.state?.pharmacy_id : null,
      pharmacy_name: this.props.history?.location?.state?.pharmacy_name ? this.props.history?.location?.state?.pharmacy_name : null,
      branch_name: this.props.history?.location?.state?.branch_name ? this.props.history?.location?.state?.branch_name : null,
      OnlyView: this.props.history?.location?.state?.OnlyView ? this.props.history?.location?.state?.OnlyView : null,
      pharmaId: null,
      isDisable: false,
      alreadySendedDrug: false,
      selectedIDs: [],
    }
  }

  componentDidMount() {
    RoleData = JSON.parse(localGetItem("loggedInUserInfo"));
    let pharmacy_type = RoleData?.pharmacy_type === 'Inhouse Pharmacy' ? "Pharmacy" : "Standalone Pharmacy";
    userAccess = CheckAccessFunc(pharmacy_type, "Purchase", 'Wanted List', null, "Tab");
    subUserAccess = CheckAccessFunc(pharmacy_type, "Purchase", 'Wanted List', 'Order List', "SubTab");
    this.getPharmaISPOEntry()
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: '',
    })
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }
  getPharmaISPOEntry() {
    try {
      this.LoaderFunction(true);
      let searchKey = this.state.searchkey ? (this.state.searchkey?.replaceAll('&', '%26')).replaceAll(',', " ") : ""
      RestAPIService.getAll(Serviceurls.INTERNALSALES_WANTEDLISTDetail +
        "?search_key=" + (searchKey) +
        "&page=" + (this.state.page + 1) +
        "&page_size=" + this.state.pageSize +
        "&from_store=true&pharmacy_id=" + this.state.pharmacy_id)
        .then((response) => {
          if (response.data.status === "success") {
            this.LoaderFunction(false);
            this.setState({
              WantedListData: response.data?.data,
              rowCount: response?.data?.total_count,
            }, () => {
              const pharmaIds = this.state.WantedListData[0]["pharmacy_id"]
              this.setState({
                pharmaId: pharmaIds
              });

            })
          }
          else {
            this.LoaderFunction(false);
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.LoaderFunction(false);
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }
  getPharmaISPOEntryPrint = () => {
    try {
      this.setState({ disableBtn: true })
      let searchKey = this.state.searchkey ? (this.state.searchkey?.replaceAll('&', '%26')).replaceAll(',', " ") : ""
      RestAPIService.getAll(Serviceurls.INTERNALSALES_WANTEDLISTDetail + `?search_key=${searchKey}&page=${this.state.page + 1}&page_size=${this.state.pageSize}&from_store=true&pharmacy_id=${this.state.pharmacy_id}&export=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ disableBtn: false })
        }).catch((error) => {
          this.errorMessage(error.message)
          this.setState({ disableBtn: false })
        })
    } catch (error) {
      this.errorMessage(error.message)
      this.setState({ disableBtn: false })
    }
  }

  getPharmaISPOEntryExcel = () => {
    const { t } = this.props;
    try {
      this.setState({ disableBtn: true })
      let searchKey = this.state.searchkey ? (this.state.searchkey?.replaceAll('&', '%26')).replaceAll(',', " ") : ""
      RestAPIService.excelGet(`${Serviceurls.INTERNALSALES_WANTEDLISTDetail}?search_key=${searchKey}&page=${this.state.page + 1}&page_size=${this.state.pageSize}&from_store=true&pharmacy_id=${this.state.pharmacy_id}&internal=true&export=${"excel"}`).
        then((response) => {
          if (response.data) {
            var pom = document.createElement('a');
            var csvContent = response.data; //here we load our csv data 

            let filename = response.headers["content-disposition"].split("filename=")[1]

            var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
            var url = URL.createObjectURL(blob);
            pom.href = url;
            pom.setAttribute('download', filename ? filename : 'registry.xlsx');
            pom.click();
            this.setState({ disableBtn: false })
          }
        }).catch((error) => {
          this.errorMessage(error.response.data?.message)
          this.setState({ disableBtn: false })
        })
    } catch (error) {
      this.errorMessage(t("PrintError"))
      this.setState({ disableBtn: false })
    }
  }

  handleTableCheckbox = (ids) => {
    const selectedIDs = new Set(ids);

    const selectedRows = this.state.WantedListData.filter((row) =>
      selectedIDs.has(row.drug_id)
    );

    this.setState({
      SelectedWantedList: selectedRows,
      selectedIDs: ids, 
    });
  };

  AddtoWantedListCart = (item) => {
    let { SelectedWantedList } = this.state
    try {
      let datas = {
        line_items: [],
        from_wanted_list: true,
        po_pharmacy_id: item?.pharmacy_id ? item?.pharmacy_id : this.state.pharmaId ? this.state.pharmaId : null,
      }
      const { t } = this.props

      if (item) { // individual select
        item["drug_ms_id"] = +item?.drug_id
        item["order_quantity"] = +item?.qty
        item["free_quantity"] = ""
        item["brand_name"] = item?.drug_name
        item["quantity"] = item?.order_quantity
        item["dosage_strength"] = item?.drug_strength
        item["expiry_date"] = ""
        item["mrp_per_quantity"] = ""
        datas['line_items']?.push(item);

      } else if (SelectedWantedList.length > 0) { // Bulk select
        SelectedWantedList.forEach((item) => {
          item["drug_ms_id"] = +item?.drug_id
          item["order_quantity"] = +item?.qty
          item["free_quantity"] = ""
          item["brand_name"] = item?.drug_name
          item["quantity"] = item?.order_quantity
          item["dosage_strength"] = item?.drug_strength
          item["expiry_date"] = ""
          item["mrp_per_quantity"] = ""
        })
        datas["line_items"] = [...SelectedWantedList];
      }

      let wantedData = {
        pharmacy_id: this.state.pharmacy_id,
        pharmacy_name: this.state.pharmacy_name,
        branch_name: this.state.branch_name,
        OnlyView: this.state.OnlyView
      }
      this.props.history.push({
        pathname: "/PharmacyInternalSales/RequestList/RequestDetail",
        state: { isFromWanted: true, wantedData: wantedData, selectedDrugData: datas }
      })

    }
    catch (e) {
      this.setState({ disableBtn: false })
      this.errorMessage(e.message)
      this.setState({ isDisable: false })
    }
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }
  gridToolBar = () => {
    return (
      <Box> <CommonGridToolBarWithFilterText /> </Box>
    )
  }
  renderCard = () => {
    return (
      <Card component={'div'} className='doc_header_card' display={"flex"} flexDirection={"row"} justifyContent={"spaceBetween"} alignItems={"spaceBetween"} height={"12vh"} width={"8vw"} >
        <Box component={'div'} padding={"2px"} display={"flex"} flexDirection={"column"} justifyContent={"spaceBetween"} >
          <Typography fontWeight={"bold"} fontSize={"1vw"}>{"Branch Name"}</Typography>
          <Typography>{this.state.branch_name}</Typography>
        </Box>

        <Box component={'div'} display={"flex"} flexDirection={"column"} justifyContent={"spaceBetween"} ml={"2vw"}>
          <Typography fontWeight={"bold"} fontSize={"1vw"}>{"Pharmacy Name"}</Typography>
          <Typography>{this.state.pharmacy_name}</Typography>

        </Box>
      </Card >
    )
  }

  renderTable = () => {
    this.state.WantedListData.forEach((element, index) => {
      let page = this.state.page
      let pageSize = this.state.pageSize
      let serial = (page * pageSize) + (index + 1)
      element.serial_no = serial
    })
    const { t } = this.props
    const columns = [
      {
        field: "serial", flex: 0.04, headerName: t("SNo"), headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.serial_no ? params?.row?.serial_no : "-"}</Box>)
      },
      {
        field: "drug_name", flex: 0.15, headerName: t("Brand Name"),
        renderCell: (params) => (params?.row?.drug_name?.length > 23 ?
          <Tooltip placement="top" title={params?.row?.drug_name} arrow><div>{params?.row?.drug_name.slice(0, 22) + "..."}</div></Tooltip>
          : <Box component={'div'}>{params?.row?.drug_name ? params?.row?.drug_name : "-"}</Box>)
      },
      {
        field: "generic_name", flex: 0.15, headerName: t("Generic Name"),
        renderCell: (params) => (params?.row?.generic_name?.length > 23 ?
          <Tooltip placement="top" title={params?.row?.generic_name} arrow><div>{params?.row?.generic_name.slice(0, 22) + "..."}</div></Tooltip>
          : <Box component={'div'}>{params?.row?.generic_name ? params?.row?.generic_name : "-"}</Box>)
      },
      {
        field: "dosage_type", flex: 0.15, headerName: t("Dosage Type / Strength"), headerAlign: "center", align: "center",
        renderCell: (params) => {
          let dosage = `${params?.row?.dosage_type ? params?.row?.dosage_type : "-"} / ${params?.row?.drug_strength ? params?.row?.drug_strength : "-"}`
          return (dosage?.length > 23 ?
            <Tooltip placement="top" title={dosage} arrow><div>{dosage.slice(0, 22) + "..."}</div></Tooltip>
            : <Box component={'div'}>{dosage ? dosage : "-"}</Box>)
        }
      },
      {
        field: "available_quantity", flex: 0.1, headerName: t("Avail.Qty"), type: "number",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.available_quantity ? params?.row?.available_quantity : "-"}</Box>)
      },
      {
        field: "mrp_per_quantity", flex: 0.1, headerName: t("Latest MRP/Qty"), type: "number",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.mrp_per_quantity ? params?.row?.mrp_per_quantity : "-"}</Box>)
      },

      {
        field: "qty", flex: 0.1, headerName: t("Order Qty/Unit"), headerAlign: "right", type: 'number',
        renderCell: (params) => (<Box component={'div'} emed_tid={`want_ordqty_${params.id}`}>
          <TextField
            inputProps={{
              style: {
                height: "2vw",
                padding: '0 14px',
              },
            }}
            disabled={!userAccess?.editAccess}
            autoComplete='off'
            value={params.row?.qty ? params.row?.qty : ""}
            onChange={(e) => {
              let number = CommonValidation.numberOnly(e.target.value);
              if (number || e.target.value === "") {
                this.state.WantedListData[params.row.serial_no - 1]["qty"] = +e.target.value
                this.setState({
                  WantedListData: this.state.WantedListData
                })
              }

            }}
            className='eMed_DataGrid_TextField' />
        </Box>)
      }
    ]

    if (userAccess?.editAccess) {
      columns.push(
        {
          field: "action", flex: 0.07, headerName: t("Action"), headerAlign: "center", align: "center", sortable: false,
          renderCell: (params) =>
            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
              <Tooltip title={t("Send Drug")} placement="top" arrow>
                <Button emed_tid='want_moveord' disabled={this.state.disableBtn || this.state.isLoader || params?.row?.already_sended_drug} className='eMed_usrconf_btn' onClick={() => { this.setState({ disableBtn: true }, () => { this.AddtoWantedListCart(params?.row) }) }}>
                  <img src={ImagePaths.PharmaPurchase.default} alt="cart" className='eMed_action_img' />
                </Button></Tooltip>
            </Box>
        }
      );
    }

    return (
      <Box component={"div"} className='eMed_Purcahse_Table_Container' height={"62vh"}  >
        <Stack component={"div"}>
          <Paper className='eMed_Purchase_Table_Wrapper' sx={{ height: "66vh" }} >
            <DataGrid
              checkboxSelection={userAccess?.editAccess}
              onRowSelectionModelChange={(id) => this.handleTableCheckbox(id)}
              rowSelectionModel={this.state.selectedIDs}
              rows={this.state.WantedListData}
              columns={columns}
              getRowId={(row) => row['drug_id']}
              hideFooterSelectedRowCount
              localeText={{
                toolbarColumns: "",
                toolbarDensity: "",
                toolbarExport: "",
                toolbarFilters: "",
                toolbarExportPrint: ""
              }}
              loading={this.state.isLoader}
              headerHeight={40}
              components={{
                Toolbar: this.gridToolBar,
                NoRowsOverlay: () => (
                  <Stack className='eMed_conf_nodata'>
                    {t("NoRecordsFound")}
                  </Stack>
                )
              }}
              pageSizeOptions={[10, 20, 30]}
              pagination
              paginationMode="server"
              paginationModel={{
                page: this.state.page,
                pageSize: this.state.pageSize
              }}
              onPaginationModelChange={(model) => {
                this.setState({
                  page: model.page,
                  pageSize: model.pageSize
                }, () => this.getPharmaISPOEntry())
              }}
              disableRowSelectionOnClick
              rowCount={this.state.rowCount}
            />
          </Paper>
        </Stack>
      </Box>
    )
  }


  render() {
    const { t } = this.props;
    return (

      <Box   >
        <Box className="eMed_Add_vendor_page_top2">
          <Stack direction="row" spacing={1} alignItems="center"><IconButton size="small" emed_tid="addvnd_bk" onClick={() => {
            this.props.history.push({ pathname: '/PharmacyInternalSales/WantedList' })
          }} >
            <img className="emedhub_popupIcon_img" src={ImagePaths.LabBackButton} alt={"Back"} />
          </IconButton>
            <Typography sx={{ color: "#616161" }}> {t("Back To Wanted List  ")}</Typography>
          </Stack>
        </Box>

        <Box className="eMed_branch_card" sx={{ width: '26vw' }} marginLeft={"0.8vw"}>

          <Box component={'div'} sx={{ width: "100%", display: "flex", columnGap: "0.5dvw", flex: 1 }}>
            <Box component={'div'} flex={0.5}>
              <Typography fontWeight={600} fontSize={"0.9vw"}>{"Branch Name"}</Typography>
              <Typography fontSize={"0.7vw"}  >{this.state.branch_name}</Typography>
            </Box>

            <Box component={'div'} flex={0.5}>
              <Typography fontWeight={600} fontSize={"0.9vw"}>{"Pharmacy Name"}</Typography>
              <Typography fontSize={"0.7vw"} >{this.state.pharmacy_name}</Typography>
            </Box>
          </Box>

        </Box>

        <div className='eMed_Purchase_Table_top' style={{ justifyContent: 'flex-end', marginTop: "-5vh" }}    >
          <div className='eMed_Purchase_Table_top' style={{ justifyContent: 'flex-end' }} >
            {subUserAccess?.viewAccess ?
              <>
                <Button emed_tid='want_ordlst' className='eMed_Filter_Btns' variant='contained' size='small'
                  disabled={this.state.SelectedWantedList?.length === 0 || this.state.isDisable}
                  onClick={() => {
                    this.setState({
                      isDisable: true
                    }, () => { this.AddtoWantedListCart() })
                  }}
                >{`Send Drug`}</Button>
              </>
              : null}
            <Tooltip title="Print" placement='top' arrow>
              <Button emed_tid='want_export' className='eMed_usrconf_btn' disabled={this.state.disableBtn} onClick={() => this.getPharmaISPOEntryPrint()}>
                <img src={ImagePaths.LabPrintIcon.default} alt="upload" className='eMed_action_img' />
              </Button></Tooltip>
            <Tooltip title="Export" placement='top' arrow>
              <Button emed_tid='want_export' className='eMed_usrconf_btn' disabled={this.state.disableBtn} onClick={() => this.getPharmaISPOEntryExcel()}>
                <img src={ImagePaths.LabUploadButton} alt="upload" className='eMed_action_img' />
              </Button></Tooltip>
          </div>
        </div>
        {this.renderTable()}
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
      </Box>
    )
  }
}
export default withTranslation()(PharmaISPoEntry)